module.exports = __webpack_public_path__ + "img/new_design.25f90e29.png";